import LoginGate from "./LoginGate";
import { getAppContext } from "../utils/getAppContext";
import { getBrandConfig } from "../utils/brandConfig";

// Shared login entry for every brand: the current brand's door (utils/brandConfig).
export default function HomeRedirect() {
  const brand = getBrandConfig(getAppContext());
  return <LoginGate brand={brand} loadingText={brand.loadingText} />;
}
